import React from 'react';
import { connect } from 'react-redux';
import './MercurXNavbar.scss';
import { Navbar } from 'react-bootstrap';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { logoutRequestAction } from '../../store/user/userActions';
import { getStoredUser } from '../../helpers/userHelper';

const MercurXNavbar = (props) => {
  const { logoutRequest } = props;
  // const history = useHistory();
  const handleLogout = () => {
    logoutRequest();
  };
  const fullName = getStoredUser()?.full_name?.trim() || 'Guest';
  const initials = fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('') || 'G';

  return (
    <Navbar expand="lg" className="mercurx-navbar px-3 px-md-4 py-2">
      <div className="mercurx-navbar__left">
        {/* <Navbar.Brand className="mercurx-navbar__brand text-fs-head-sm mb-0">
          Backoffice
        </Navbar.Brand> */}
        <span className="mercurx-navbar__subtitle text-fs-tag">Backoffice</span>
      </div>

      <div className="mercurx-navbar__right">
        <div className="mercurx-navbar__user-card" title={fullName}>
          <div className="mercurx-navbar__avatar">{initials}</div>
          <div className="mercurx-navbar__user-meta">
            <span className="mercurx-navbar__user-name">{fullName}</span>
            <span className="mercurx-navbar__user-role">Authorized User</span>
          </div>
        </div>

        <button type="button" className="mercurx-navbar__logout-btn" onClick={handleLogout}>
          <MercurXIcons name="BsArrowBarRight" size={18} />
          <span>Logout</span>
        </button>
      </div>
    </Navbar>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    logoutRequest: (payload) => {
      dispatch(logoutRequestAction(payload));
    },
  };
};

export default connect(null, mapDispatchToProps)(MercurXNavbar);
